module.exports = __webpack_public_path__ + "assets/ontraport.8a3afad8.svg";